<template>
  <div v-if="data_sensor">
    <!-- <pre>{{data_gateway[1]}}</pre> -->
    <vs-row>
      <vs-col class="col-reponsive" vs-type="flex" vs-align="center" vs-w="12">
        <div class="brd_header">
          <h3 class="header_text">Temperature Sensor</h3>
        </div>

        <vs-spacer />
        <div class="brd_header">
          <h4 class="header_text">
            Report
            <vs-icon
              class="ml-1"
              icon="logout"
              size="20px"
              color="#111111"
            ></vs-icon>
          </h4>
        </div>
      </vs-col> </vs-row
    ><br />
    <vs-row vs-w="12">
      <vs-col
        class="col-reponsive"
        vs-type="flex"
        vs-justify="center"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
        <div class="carddiv container">
          <div class="center">
            <vs-row
              vs-align="center"
              vs-type="flex"
              vs-justify="space-around"
              vs-w="12"
            >
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <img class="deviceimg" src="@/assets/images/d-net/device.png" />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="right"
                vs-align="center"
                vs-w="8"
              >
                <div class="colortext">
                  <div>
                    <h1 class="text_temp">Temp Sensor01</h1>
                  </div>
                  <br />
                  <div>
                    <h1 class="digitext">
                      {{
                        Cdata_sensor[0]?Cdata_sensor[0][0].sensordata.temperature.toFixed(1):'null'
                      }}°C
                    </h1>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
      <vs-col
        class="col-reponsive"
        vs-type="flex"
        vs-justify="center"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
        <div class="carddiv container">
          <div class="center">
            <vs-row
              vs-align="center"
              vs-type="flex"
              vs-justify="space-around"
              vs-w="12"
            >
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <img class="deviceimg" src="@/assets/images/d-net/device.png" />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="right"
                vs-align="center"
                vs-w="8"
              >
                <div class="colortext">
                  <div>
                    <h1 class="text_temp">Temp Sensor02</h1>
                  </div>
                  <br />
                  <div>
                    <h1 class="digitext">
                      {{ data_sensor[0]?data_sensor[0][data_sensor[0].length-1].sensordata.temperature.toFixed(1):'null' }}
                      °C
                    </h1>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-lg="4" vs-sm="4" vs-xs="12">
        <div class="container">
          <div class="carddiv mb-4 container">
            <br />
            <vs-row>
              <h4 id="text1">Temp Sensor01</h4>
              <vs-spacer />
              <div>
                <ul class="listnone">
                  <li>
                    <p id="text2">
                      Date :
                      {{
                        Cdata_sensor[0]?$moment(Cdata_sensor[0][0].timestamp).format(
                          "YYYY-MM-DD"
                        ):'YYYY-MM-DD'
                      }}
                    </p>
                  </li>
                  <li>
                    <p id="text3">
                      Time :
                      {{
                        Cdata_sensor[0]?$moment(Cdata_sensor[0][0].timestamp).format("hh:mm:ss"):'hh:mm:ss'
                      }}
                    </p>
                    <!-- {{ Cdata_sensor[0][Cdata_sensor[0].length - 1] }} -->
                  </li>
                </ul>
              </div>
            </vs-row>
            <vs-row>
              <ul class="listnone" align="center">
                <li id="text4">
                  {{ data_sensor[0]?data_sensor[0][0].sensordata.temperature.toFixed(1):'null' }}°C
                </li>
                <li id="text5">Temperature</li>
              </ul>
              <vs-spacer />
              <div>
                <ul class="listnone" align="center">
                  <li id="text6">
                    {{ data_sensor[0]?data_sensor[0][0].sensordata.humidity.toFixed(1):'null' }}%
                  </li>
                  <li id="text7">Humidity</li>
                </ul>
              </div>
            </vs-row>
          </div>
          <div class="carddiv container">
            <br />
            <vs-row>
              <h4 id="text1">Fridge Sensor02</h4>
              <vs-spacer />
              <div>
                <ul class="listnone">
                  <li>
                    <p id="text2">Date :</p>
                  </li>
                  <li>
                    <p id="text3">Time :</p>
                  </li>
                </ul>
              </div>
            </vs-row>
            <vs-row>
              <ul class="listnone" align="center">
                <li id="text4">
                  {{ data_sensor[0]?data_sensor[0][data_sensor[0].length-1].sensordata.temperature.toFixed(1):'null' }}°C
                  
                </li>
                <li id="text5">Temperature</li>
              </ul>
              <vs-spacer />
              <div>
                <ul class="listnone" align="center">
                  <li id="text6">
                    {{ data_sensor[0]?data_sensor[0][data_sensor[0].length-1].sensordata.humidity.toFixed(1):'null' }}%
                    
                  </li>
                  <li id="text7">Humidity</li>
                </ul>
              </div>
            </vs-row>
          </div>
        </div>
      </vs-col> </vs-row
    ><br />
    <vs-row vs-w="12">
      <vs-col
        class="col-reponsive"
        vs-type="flex"
        vs-justify="center"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card class="cardBorder">
          <vs-row>
            <vs-select width="150px" v-model="select_temp">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options1"
              /> </vs-select
            ><vs-spacer /><vs-select width="150px" v-model="select_duration">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in options2"
              /> </vs-select></vs-row
          ><br />
          <div style="position: relative; width: 100%">
            <displaychart
              width="300"
              height="300"
              :chartdata="Cchartdata"
              :color="color"
            />
            <!-- <lineChart
              width="300"
              height="300"
              :chartData="chartdata"
              :options="optiochart"
            ></lineChart> -->
          </div>
          <vs-row class="aText">
            <div class="divwi color1">.</div>
            <a class="ml-1">Temperature </a>
            <div class="divwi color2 ml-2">.</div>
            <a class="ml-1">Humidity</a>
            <vs-spacer />
            <div class="mr-4">
              <p style="color: #fc8200" class="mb-1">avg</p>
              <p>22 °C</p>
            </div>
            <div class="mr-4">
              <p style="color: #ff006a" class="mb-1">min</p>
              <p>22 °C</p>
            </div>
            <div class="mr-4">
              <p style="color: #d400ff" class="mb-1">max</p>
              <p>22 °C</p>
            </div>
          </vs-row></vs-card
        >
      </vs-col>
      <vs-col
        class="col-reponsive"
        vs-type="flex"
        vs-justify="center"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card class="cardBorder"
          ><vs-row class="mt-2 mb-3"
            ><h4 id="text1">Temperature Sensor List</h4></vs-row
          >
          <b-table-simple
            style="overflow-y: auto; max-height: 310px"
            hover
            responsive="sm"
          >
            <b-thead style="position: sticky; top: 0; z-index: 2">
              <b-tr class="bgHeader">
                <b-th v-for="i in header" :key="i"
                  ><b>{{ i }}</b></b-th
                >
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="i in data_sensor[0]" :key="i">
                <b-td class="fontsizetable" align="center">
                  {{ i.timestamp }}
                </b-td>
                <b-td class="fontsizetable" align="center">
                  Fridge Sensor02</b-td
                >
                <b-td class="fontsizetable" align="center"> {{ i.mac }}</b-td>
                <b-td class="fontsizetable" align="center">
                  {{ i.sensordata.temperature }}°C</b-td
                >
                <b-td class="fontsizetable" align="center">
                  {{ i.sensordata.humidity }}%</b-td
                >
                <b-td class="fontsizetable" align="center">
                  {{ i.sensordata.battery }}</b-td
                >
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import lineChart from "./chart";
import displaychart from "./displaychart.vue";
export default {
  components: {
    lineChart,
    displaychart,
  },
  data: () => ({
    mintime: "",
    maxtime: "",
    dataExport: [],
    data_sensor: [],
    data_gateway: [],
    data_chiller: [],
    date_chiller: [],
    time_chiller: [],
    data_freezer: [],
    date_freezer: [],
    time_freezer: [],
    select_temp: 1,
    select_duration: 1,
    options1: [
      { text: "Temp 01", value: 1 },
      { text: "Temp 02", value: 2 },
    ],
    options2: [
      { text: "1 Day", value: 1 },
      { text: "2 Day", value: 2 },
    ],
    header: [
      "Timestamp",
      "Sensor Name",
      "Mac Address",
      "Temperature",
      "Humidity",
      "Battery",
    ],
    gradient: null,
    color: ["#4DC4FF", "#b38dff"],
    chartdata: {
      labels: ["8 pm", "9 pm", "10 pm", "11 pm", "12 pm", "1 am", "2 am"],
      value: [22, 19, 22, 11, 16, 11, 10],
      value2: [10, 14, 13, 15, 11, 24, 19],
    },
    labels: ["8 pm", "9 pm", "10 pm", "11 pm", "12 pm", "1 am", "2 am"],
    optiochart: null,
    backgroundColorY: "rgba(255, 195, 0,.1)",
    borderColorY: "#FFC300",
    interval: null,
  }),
  computed: {
    Cdata_sensor: {
      // getter
      get: function () {
        return this.data_sensor;
      },
      // setter
      set: function (newValue) {
        this.data_sensor = newValue;
      },
    },
    Cchartdata: {
      // getter
      get: function () {
        return this.chartdata;
      },
      // setter
      set: function (newValue) {
        this.chartdata = newValue;
      },
    },
  },
  methods: {
    chart() {
      // this.gradient = this.$refs.canvas
      //     .getContext("2d")
      //     .createLinearGradient(0, 0, 0, 200);
      //   let gradientStep1 = this.color;
      //   let gradientStep2 = this.color+"7a";
      //   let gradientStep3 = this.color+"00";
      //   this.gradient.addColorStop(0, gradientStep1);
      //   this.gradient.addColorStop(0.5, gradientStep2);
      //   this.gradient.addColorStop(1, gradientStep3);
    },
    graphPH3() {
      this.gradient = this.$refs.canvas
        .getContext("2d")
        .createLinearGradient(0, 0, 0, 200);
      let gradientStep1 = this.color;
      let gradientStep2 = this.color + "7a";
      let gradientStep3 = this.color + "00";
      this.gradient.addColorStop(0, gradientStep1);
      this.gradient.addColorStop(0.5, gradientStep2);
      this.gradient.addColorStop(1, gradientStep3);
      console.log(this.gradient);
      console.log("111111111111111");
      this.chartdata = {
        labels: this.chartdata.labels,
        datasets: [
          {
            backgroundColor: "rgba(179, 141, 255,.1)",
            data: this.chartdata.value,
            borderWidth: 1.5,
            borderColor: "#4DC4FF",
          },
          {
            backgroundColor: "rgba(179, 141, 255,.1)",
            data: this.chartdata.value,
            borderWidth: 1.5,
            borderColor: "#b38dff",
          },
        ],
      };
      this.optiochart = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                steps: 10,
                stepValue: 5,
                max: 30,
              },
              position: "left",
              // scaleLabel: {
              //   display: true,
              //   labelString: "pH Value (pH)",
              // },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              // scaleLabel: {
              //   display: true,
              //   labelString: "Timestamp",
              // },
            },
          ],
        },
      };
    },
  async  getTempdata() {
      let username = this.$session.get("username");
      let Mac = username == "tempdemo01" ? "AC233FC0C2EF" : "AC233FC064BF";
      console.log(username, Mac);
      this.data_sensor = [];
      this.chartdata = {};
     await this.$API.get(`indoorgateway/` + Mac).then((result) => {
        console.log(result.data);
        this.data_gateway = result.data;
        for (let i = 0; i < this.data_gateway[0].sensorfound.length; i++) {
          const element = this.data_gateway[0].sensorfound[i];
          let sensormac =
            username == "tempdemo01" ? "AC233FA05B14" : "AC233FA05B31";

          this.$API.get(`indoorsensorlog/` + sensormac).then((res) => {
            console.log(res);
            let temp = [];
            let humidity = [];
            let label = [];
            let sortdata = [];
            for (let j = res.data.length - 1; j > 0; j--) {
              const el = res.data[j];
              console.log(el.timestamp);
              temp.push(el.sensordata.temperature);
              humidity.push(el.sensordata.humidity);
              label.push(
                this.$moment(el.timestamp).format("YYYY-MM-DD hh:mm:ss")
              );
              el.timestamp = this.$moment(el.timestamp).format(
                "YYYY-MM-DD hh:mm:ss"
              );
              sortdata.push(el);
            }
            this.data_sensor.push(sortdata);
            // this.Cdata_sensor
            console.log(this.data_sensor);
            this.chartdata = {
              labels: label,
              value: temp,
              value2: humidity,
            };
          });
        }
      });
       this.interval = setTimeout(() => {
      this.getTempdata();
      // console.log("555");
    }, 1000 * 10);
    },
  },

  mounted() {
    // Customer: {customer_name: 'แมคโดนัลด์'}
    // branch_code: "00001"
    // branch_eng: "MC-mahidol_salaya"
    // branch_name: " แมคโดนัลด์ ไดร์ฟทรูมหิดล ศาลายา"
    // chiller: "AC233FA98880"
    // customer_id: 6
    // freezer: "AC233FA98889"
    // gatewayMAC: "AC233FC0C2F9"
    // id: 1

    // this.$API.get("indoorsensor").then((result) => {
    //   console.log(result);
    // this.data_sensor = result.data;

    // this.data_sensor.forEach((element) => {
    //   // console.log(element);
    //   if (element.mac == this.data.chiller) {
    //     this.data_gateway.push(element);
    //     this.data_chiller.push(element);
    //     this.sdata.push({ text: "Chiller", value: element.mac });
    //     this.date_chiller.push(
    //       this.$moment(element.lastdate).format("DD/MM/YYYY")
    //     );
    //     this.time_chiller.push(
    //       this.$moment(element.lastdate).format("hh:mm A")
    //     );
    //   } else if (element.mac == this.data.freezer) {
    //     this.data_freezer.push(element);
    //     this.data_gateway.push(element);
    //     this.sdata.push({ text: "Freezer", value: element.mac });
    //     this.date_freezer.push(
    //       this.$moment(element.lastdate).format("DD/MM/YYYY")
    //     );
    //     this.time_freezer.push(
    //       this.$moment(element.lastdate).format("hh:mm A")
    //     );
    // }
    // });
    // });
    this.getTempdata();

    // this.graphPH3();
    // console.log("sdfsdf", this.data_sensor);

   
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
};
</script>

<style scoped>
@font-face {
  font-family: "7 Segment";
  src: local("7 Segment"),
    url("./../../../../../src/assets/Font/7-Segment-Font/Seven Segment.ttf")
      format("truetype");
}
.header_text {
  font-weight: 550;
  font-size: 130%;
}
.fontsizetable {
  color: var(--text-color);
}
.aText {
  align-items: center;
}
.divwi {
  width: 6.5%;
  border-radius: 20px;
  height: 2%;
}
.color1 {
  background-color: #b38dff;
  color: #b38dff;
}
.color2 {
  background-color: #4dc4ff;
  color: #4dc4ff;
}
.bgHeader {
  background: #f8f9fa;
  color: #5b5777;
  /* font-size: 0.7rem; */
}
.cardBorder {
  border-radius: 20px;
}
.brd_header {
  background: var(--background-color-sidebar);
  padding: 15px;
  padding-top: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
  border-radius: 20px;
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
}
.deviceimg {
  width: 250%;
}
.listnone {
  list-style: none;
}
.carddiv {
  width: 100%;
  height: auto;
  background: var(--background-color-sidebar);
  border-radius: 20px;
  display: block;
  -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.colortext {
  color: #6c757d;
}
.digitext {
  font-family: "7 Segment";
  font-size: 500%;
}
#text1 {
  font-weight: 550;
}
#text2 {
  /* color: grey; */
  font-size: 85%;
}
#text3 {
  /* color: grey; */
  font-size: 85%;
}
#text4 {
  color: #ffde3d;
  font-size: 32px;
  font-weight: 550;
}
#text5 {
  font-weight: 550;
}
#text6 {
  color: #2ba0ff;
  font-size: 32px;
  font-weight: 550;
}
#text7 {
  font-weight: 550;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .col-reponsive {
    padding: 15px;
  }
  .deviceimg {
    width: 150%;
  }
}
</style>